import { Grid } from '@mui/material';
import { memo, useMemo } from 'react';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import { FormikProps } from 'formik';
import ItalianForm from '../../../step-residence/modal-new-residence/italian';
import { useEventCallback } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { ItalianVM, RegisterOfficeVM } from 'shell/view-models/register-office-practice-vm';

interface FormProps {
  disabled?: boolean;
  formContext: FormikProps<RegisterOfficeVM>;
  onSave: () => void;
}

const FormComponent = ({ formContext, onSave }: FormProps): React.ReactElement => {
  const isEffectiveDateFiled: boolean | undefined | null = useMemo(() => {
    return (
      formContext.values?.residenceTemporary?.effectiveDate &&
      formContext.values?.residenceTemporary?.effectiveDate?.toString() !== 'Invalid DateTime'
    );
  }, [formContext.values?.residenceTemporary?.effectiveDate]);

  const onChangeItalian = useEventCallback(
    (key: keyof ItalianVM, value: ItalianVM[keyof ItalianVM]) => {
      formContext.setFieldValue('residenceTemporary', {
        ...(formContext.values.residenceTemporary || {}),
        italian: {
          ...(formContext.values.residenceTemporary?.italian || {}),
          [key]: value,
        },
      });
    }
  );

  const onChangesItalian = useEventCallback((values: ItalianVM) => {
    formContext.setFieldValue('residenceTemporary', {
      ...(formContext.values.residenceTemporary || {}),
      italian: {
        ...(formContext.values.residenceTemporary?.italian || {}),
        ...(values || {}),
      },
    });
  });

  return (
    <Grid item container spacing={2}>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Decorrenza"
          aria-label="Decorrenza"
          value={formContext.values?.residenceTemporary?.effectiveDate || null}
          onChange={(date) => {
            formContext.setFieldValue('residenceTemporary', {
              ...(formContext.values.residenceTemporary || {}),
              effectiveDate: date || null,
            });
          }}
          // disabled={formContext.values.residenceTemporary?.isFromData || disabled}
          renderInput={(params) => (
            <PmiTextField
              id="effectiveDate"
              {...params}
              fullWidth
              helperText=""
              // error={formContext.touched.effectiveDate && Boolean(formContext.errors.effectiveDate)}
              // helperText={formContext.errors.effectiveDate}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        {isEffectiveDateFiled ? (
          <ItalianForm
            onChange={onChangeItalian}
            onChanges={onChangesItalian}
            // errors={
            //   (formContext?.errors?.residence as unknown as FormikErrors<FormActualResidenceVM>)
            //     ?.italian as unknown as FormikErrors<ItalianVM>
            // }
            // touched={
            //   (formContext?.touched?.residence as unknown as FormikTouched<FormActualResidenceVM>)
            //     ?.italian as unknown as FormikTouched<ItalianVM>
            // }
            values={formContext?.values?.residenceTemporary?.italian}
          />
        ) : undefined}
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiButton variant="outlined" fullWidth color="cdmBrandThird" onClick={onSave}>
          Avanti
        </PmiButton>
      </Grid>
    </Grid>
  );
};

FormComponent.displayName = 'Accordion Residence - form';

const Form = memo(FormComponent);

export default Form;
